import { AuthLayoutVue } from "fs-pb-vue2/vueModels/layouts/AuthLayoutVue";
import { NewsData } from "fs-pb-vue2/data/newsData";
import { AuthApi } from "fs-pb-vue2/services/api/AuthApi";

/**Модель представления авторизованной страницы */
export class AuthLayoutVueGB extends AuthLayoutVue {

  bankNews: Array<NewsData> = [];

  bankTariffs: any = null;

  showAll: boolean = false;

  /**Инициализация стартовых данных приложения */
  async getBankNews(): Promise<void> {
  	try {
  		this.bankNews = await AuthApi.getBankNews();
  	} catch (e: any) {
	      // for (let i = 0; i < 16; i++) {
	      //   this.bankNews.push(new NewsData({
	      //     Description: 'С 1 февраля 2023 года вступает в силу новая редакция Тарифов комиссионного вознаграждения за проведение расчетов по операциям с использованием банковских карт при реализации предприятием товаров (работ/услуг) в рамках оказания услуг торгового эквайринга, интернет-эквайринга, а также системы быстрых платежей.  Ознакомиться с новой редакцией тарифов можно в разделе «Эквайринг» на сайте Банка, либо в ближайшем офисе АО «ГЕНБАНК».  Связаться с нами можно по телефону Единого Информационного Центра 8-800-333-55-45 (звонок по России бесплатный).',
	      //     Title: 'С 1 февраля начнут действовать новые тарифы на услуги торгового эквайринга, интернет-эквайринга, а также системы быстрых платежей',
	      //     PublishDate: '/Date(1674203100000)/',
	      //     Link: 'https://www.genbank.ru/allnews/2081-s-1-fevralya-nachnut-dejstvovat-novye-tarify-na-uslugi-torgovogo-ekvajringa-internet-ekvajringa-a-takzhe-sistemy-bystrykh-platezhej'
	      //   }))
	      // }
  		console.log(e.message);
  	}
  }

  async getBankTariffs(): Promise<void> {
  	try {
  		this.bankTariffs = await AuthApi.getBankTariffs();
  	} catch(e: any) {
  		this.alertService.error(e.message);
  	}
  }

}
